import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCroissant } from '@fortawesome/pro-solid-svg-icons'

interface LogoProps {
  className?: string
  showText?: boolean
  textClassName?: string
  logoClassName?: string
}

const Logo: React.FC<LogoProps> = ({
  className = '',
  showText = true,
  textClassName = '',
  logoClassName = '',
}) => {
  return (
    <div className={`logo-container ${className}`}>
      <FontAwesomeIcon
        icon={faCroissant}
        className={`logo-croissant ${logoClassName}`}
      />
      {showText && (
        <h1 className={`logo-title ${textClassName}`}>
          Bread<span className="logo-title-accent">GPT</span>
        </h1>
      )}
    </div>
  )
}

export default Logo
